import { Injectable } from '@angular/core';
// LogRocket dynamically imported to avoid CommonJS in initial bundle.
// Dynamic import returns a module object; we unwrap default for ergonomic usage.
let _logRocket: any | null = null; // holds the default export object with init/identify/etc.
async function getLogRocket(): Promise<any> {
  if (_logRocket) return _logRocket;
  try {
    const mod: any = await import('logrocket');
    _logRocket = mod?.default ?? mod; // UMD / CJS interop
  } catch (e) {
    console.warn('[logrocket] failed dynamic import', e);
    _logRocket = {};
  }
  return _logRocket;
}
import * as Sentry from '@sentry/browser';
import { Store } from '@ngrx/store';
import { IAppState } from '@app/core/state/state.service';
import { selectCurrentUser } from '@app/core/auth/auth.selectors';
import { AppConfigService } from '@core/services/config/app-config.service';

@Injectable({
  providedIn: 'root',
})
export class LogRocketService {
  constructor(private _store: Store) {}

  init() {
    if (!AppConfigService.staticConfig.logRocketEnabled) {
      return;
    }
    getLogRocket().then((lr) => {
      try {
        lr?.getSessionURL?.((sessionURL: string) => {
          try { Sentry.getGlobalScope().setTag('sessionURL', sessionURL); } catch {/* ignore */}
        });
      } catch (e) {
        console.warn('[logrocket] getSessionURL failed', e);
      }
    });

    this._store.select(selectCurrentUser).subscribe((user) => {
      if (!user) return;
      getLogRocket().then((lr) => {
        try {
          lr?.identify?.(user.id, {
            name: `${user.fullName.first} ${user.fullName.surname}`,
            email: user.email,
            preferredName: user.fullName.preferred ?? '',
          });
        } catch (e) {
          console.warn('[logrocket] identify failed', e);
        }
      });
    });
  }
}
